
// =============================================
// File: client/src/graphql/loans.js
// Purpose: Centralize loan-related GraphQL ops
// =============================================
import { gql } from "@apollo/client";

// 🔁 Query: loan products shown in the product dropdown
export const GET_LOAN_PRODUCTS = gql`
  query {
    loanProducts {
      createdBy
      createdDate
      durationInMonths
      groupId
      id
      interestRate
      isActive
      name
      updatedBy
      updatedDate
    }
  }
`;

// 🔁 Query: members who can be selected as guarantors
export const GET_ELIGIBLE_GUARANTORS = gql`
  query {
    users(user: { }) {
      address
      changePassword
      createdBy
      createdDate
      email
      firstName
      group
      groupId
      groupLogoPath
      id
      idNumber
      isActive
      lastLogin
      lastName
      loginAttempts
      password
      phoneNumber
      role
      roleGroup
      roleId
      updatedBy
      updatedDate
      username
    }
  }
`;

// ✅ Mutation: submit the loan application
export const BOOK_LOAN_APPLICATION = gql`
  mutation BookLoanApplication($input: BookLoanApplicationInput!) {
    bookLoanApplication(input: $input) {
      status
      errorMessage
    }
  }
`;

// 🔁 Query: user loan applications (used by table + refetch after submit)
export const GET_LOAN_APPLICATIONS = gql`
  query GetUserLoanApplications {
    userLoanApplications {
      id
      loanProduct
      requestedAmount
      calculatedInterest
      totalRepayableAmount
      disbursementDate
      disbursementPhoneNumber
      reasonForRejection
      status
      applicationDate
      dueDate
    }
  }
`;

// 🔁 Query: user repayment schedule (unchanged, here for convenience)
export const GET_REPAYMENT_SCHEDULE = gql`
  query GetRepaymentSchedule {
    userLoanRepaymentSchedule {
      id
      loanApplicationId
      dueDate
      principalDue
      principalPaid
      interestDue
      interestPaid
      status
    }
  }
`;

// 🔁 Query: reminder schedules configured for the group's loan products
export const GET_LOAN_PRODUCT_REMINDER_SCHEDULES = gql`
  query GetLoanProductReminderSchedules {
    loanProductReminderSchedules {
      createdAtUtc
      daysBeforeDue
      groupId
      id
      isActive
      loanProductId
      loanProductName
      updatedAtUtc
    }
  }
`;

// ✅ Mutation: create/update reminder schedule for a specific loan product
export const UPSERT_LOAN_PRODUCT_REMINDER_SCHEDULE = gql`
  mutation UpsertLoanProductReminderSchedule($newSchedule: LoanProductReminderScheduleInput!) {
    createLoanProductReminderSchedule(newSchedule: $newSchedule) {
      createdAtUtc
      daysBeforeDue
      id
      isActive
      loanProductId
      updatedAtUtc
    }
  }
`;
